module.exports = __webpack_public_path__ + "static/img/kh-10.fe16134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-10.png
// module id = M28N
// module chunks = 5